import axios from '@/config/axios';
import { useCallback, useEffect, useState } from 'react';
import { useEntraAuth } from './useEntraAuth';

export type ContractType =
    | 'terms-and-conditions'
    | 'nra-terms-and-conditions'
    | 'protection-plan'
    | 'shipping-rates'
    | 'end-user-ultimate-destination'
    | 'bill-of-sale';

export type ContractData = {
    acceptedAt: string;
    documentHtml: string;
    id: number;
    updatedAt: string;
};

export const useContractsData = (type: ContractType) => {
    const { isAuthenticated } = useEntraAuth();
    const [data, setData] = useState<ContractData | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorStatus, setErrorStatus] = useState<number | null>(null);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        setErrorStatus(null);
        try {
            const { data } = await axios.get(`/api/contracts/${type}`);
            setData(data);
        } catch (error: any) {
            if (error.response) {
                setErrorStatus(error.response.status);
            } else {
                setErrorStatus(500);
            }
        } finally {
            setIsLoading(false);
        }
    }, [type]);

    useEffect(() => {
        if (isAuthenticated) {
            fetchData();
        }
    }, [fetchData, isAuthenticated]);

    return {
        isLoading,
        data,
        errorStatus,
        fetchData,
    };
};
